/**
 * Italian translations
 */
export default {
    // Auth
    'auth.sign_in': 'Accedi',
    'auth.sign_in_to': 'Accedi a {app}',
    'auth.enter_email_to_continue': 'Inserisci la tua e-mail per continuare',
    'auth.email_label': 'Indirizzo e-mail',
    'auth.email_placeholder': 'you@example.com',
    'auth.continue': 'Continua',
    'auth.checking': 'Verifica...',
    'auth.sign_out': 'Esci',
    'auth.signing_in': 'Accesso in corso...',
    'auth.signed_in_redirecting': 'Accesso effettuato! Reindirizzamento...',
    'auth.signed_in_close_tab': 'Accesso effettuato! Puoi chiudere questa scheda.',
    'auth.check_email': 'Controlla la tua e-mail',
    'auth.sign_in_link_sent': 'Abbiamo inviato un link di accesso a {email}',
    'auth.click_link_to_continue': 'Clicca sul link per continuare',
    'auth.first_signup_approval': 'Se ti stai registrando per la prima volta, la tua richiesta potrebbe richiedere approvazione prima dell\'invio del link di accesso.',
    'auth.didnt_receive_try_again': 'Non l\'hai ricevuto? Riprova',
    'auth.click_link_to_sign_in': 'Clicca sul link nell\'e-mail per accedere.',
    'auth.resend_email': 'Invia di nuovo l\'e-mail',
    'auth.use_different_email': 'Usa un\'altra e-mail',
    'auth.passkey_available': 'Passkey disponibile',
    'auth.sign_in_with_passkey': 'Accedi con passkey',
    'auth.security_key_required': 'Chiave di sicurezza richiesta',
    'auth.use_security_key_to_sign_in': 'Usa la tua chiave di sicurezza per accedere a {email}',
    'auth.sign_in_with_security_key': 'Accedi con chiave di sicurezza',
    'auth.waiting_for_device': 'In attesa del dispositivo...',
    'auth.verifying': 'Verifica...',
    'auth.lost_device_access': 'Non hai più accesso al tuo dispositivo?',
    'auth.lost_security_key_access': 'Non hai più accesso alla tua chiave di sicurezza?',
    'auth.link_opened_different_device': 'Link aperto su un altro dispositivo',
    'auth.enter_verification_code': 'Inserisci il codice di verifica mostrato:',
    'auth.verify_code': 'Verifica codice',
    'auth.please_enter_email': 'Inserisci il tuo indirizzo e-mail',
    'auth.please_enter_valid_email': 'Inserisci un indirizzo e-mail valido',
    'auth.please_enter_6_digit_code': 'Inserisci il codice a 6 cifre',
    'auth.please_enter_valid_6_digit_code': 'Inserisci un codice a 6 cifre valido',
    'auth.session_expired': 'Sessione scaduta. Riprova.',
    'auth.session_expired_request_new': 'Sessione scaduta. Richiedi un nuovo link di accesso.',
    'auth.signin_replaced': 'Questo accesso è stato sostituito da una nuova richiesta. Controlla la tua e-mail.',
    'auth.authentication_failed': 'Autenticazione fallita. Riprova.',
    'auth.failed_send_link': 'Invio del link di accesso fallito. Riprova.',
    'auth.failed_verify_code': 'Verifica del codice fallita. Riprova.',
    'auth.webauthn_not_supported': 'Le chiavi di sicurezza non sono supportate in questo browser',
    'auth.unexpected_error': 'Si è verificato un errore imprevisto. Riprova.',
    'auth.invalid_or_missing_token': 'Token di verifica non valido o mancante',
    'auth.verification_failed': 'Verifica fallita. Riprova.',
    'auth.keep_signed_in_question': 'Restare connesso?',
    'auth.keep_signed_in_description': 'Su un computer condiviso o pubblico, scegli \u201cNon ora\u201d \u2014 la tua sessione terminer\u00e0 dopo 30 minuti di inattivit\u00e0.',
    'auth.keep_signed_in_yes': 'Resta connesso',
    'auth.keep_signed_in_no': 'Non ora',

    // Settings
    'settings.title': 'Impostazioni',
    'settings.profile': 'Profilo',
    'settings.profile_display_name': 'Nome visualizzato',
    'settings.profile_display_name_placeholder': 'Inserisci il tuo nome',
    'settings.profile_display_name_help': 'Questo nome verrà mostrato al posto della tua e-mail',
    'settings.profile_not_set': 'Non impostato',
    'settings.profile_avatar': 'Avatar',
    'settings.profile_avatar_upload': 'Carica',
    'settings.profile_avatar_help': 'JPG, PNG, GIF o WebP. Max 2 MB.',
    'settings.profile_avatar_too_large': 'La dimensione del file deve essere di 2 MB o meno',
    'settings.profile_avatar_invalid_type': 'Il file deve essere JPG, PNG, GIF o WebP',
    'settings.profile_avatar_updated': 'Avatar aggiornato',
    'settings.profile_avatar_removed': 'Avatar rimosso',
    'settings.profile_avatar_remove_confirm': 'Rimuovere il tuo avatar?',
    'settings.profile_timezone': 'Fuso orario',
    'settings.profile_timezone_select': 'Seleziona fuso orario',
    'settings.profile_timezone_search': 'Cerca fusi orari...',
    'settings.profile_updated': 'Profilo aggiornato',
    'settings.language': 'Lingua',
    'settings.language_description': 'Scegli la tua lingua preferita',
    'settings.sessions': 'Sessioni',
    'settings.sessions_description': 'Gestisci le tue sessioni attive',
    'settings.security': 'Sicurezza',
    'settings.security_description': 'Gestisci le tue chiavi di sicurezza e passkey',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.welcome': 'Benvenuto, {name}',
    'dashboard.edit_profile': 'Modifica profilo',
    'dashboard.member_since': 'Membro da {date}',
    'dashboard.services': 'Servizi',
    'dashboard.account': 'Account',
    'dashboard.organizations_title': 'Organizzazioni',
    'dashboard.organizations_description': 'Gestisci le tue organizzazioni',
    'dashboard.domains_title': 'Domini',
    'dashboard.domains_description': 'Configura domini e DNS',
    'dashboard.mailboxes_title': 'Caselle',
    'dashboard.mailboxes_description': 'Account e-mail e archiviazione',
    'dashboard.aliases_title': 'Alias',
    'dashboard.aliases_description': 'Regole di inoltro e-mail',
    'dashboard.settings_title': 'Impostazioni',
    'dashboard.settings_description': 'Profilo e sicurezza',
    'dashboard.support_title': 'Supporto',
    'dashboard.support_description': 'Contatta il supporto',

    // Support
    'support.title': 'Supporto',
    'support.description': 'Hai una domanda o hai bisogno di aiuto? Inviaci un messaggio e ti risponderemo a {email}. Se preferisci essere contattato a un altro indirizzo o desideri essere richiamato, indicalo nel tuo messaggio.',
    'support.organization': 'Organizzazione',
    'support.no_organization': 'Richiesta generale (nessuna organizzazione)',
    'support.organization_help': 'Facoltativo. Seleziona se la tua richiesta riguarda un\'organizzazione specifica.',
    'support.subject': 'Oggetto',
    'support.message': 'Messaggio',
    'support.message_placeholder': 'Descrivi la tua domanda o il tuo problema...',
    'support.send': 'Invia',
    'support.sending': 'Invio in corso...',
    'support.sent': 'Messaggio inviato',
    'support.sent_description': 'Abbiamo ricevuto il tuo messaggio e ti ricontatteremo.',
    'support.send_another': 'Invia un altro messaggio',
    'support.fields_required': 'Oggetto e messaggio sono obbligatori.',
    'support.send_error': 'Impossibile inviare il messaggio. Riprova.',

    // Common
    'common.save': 'Salva',
    'common.cancel': 'Annulla',
    'common.delete': 'Elimina',
    'common.edit': 'Modifica',
    'common.add': 'Aggiungi',
    'common.remove': 'Rimuovi',
    'common.confirm': 'Conferma',
    'common.ok': 'OK',
    'common.close': 'Chiudi',
    'common.back': 'Indietro',
    'common.next': 'Avanti',
    'common.loading': 'Caricamento...',
    'common.error': 'Errore',
    'common.success': 'Successo',

    // Errors
    'error.generic': 'Si è verificato un errore. Riprova.',
    'error.network': 'Errore di rete. Controlla la tua connessione.',
    'error.unauthorized': 'Non sei autorizzato a eseguire questa azione.',
    'error.not_found': 'La risorsa richiesta non è stata trovata.',

    // Admin forward conversion
    "admin.forward_conversion.title": "Converti un inoltro in alias della casella",
    "admin.forward_conversion.button": "Converti",
    "admin.forward_conversion.description": "Converti un inoltro in alias se la destinazione è una casella attiva di questa organizzazione. L’indirizzo e la sua cronologia vengono conservati.",
    "admin.forward_conversion.empty": "Nessun inoltro idoneo. La destinazione deve essere una casella attiva di questa organizzazione, senza un alias esistente verso la stessa casella per lo stesso indirizzo.",
    "admin.forward_conversion.search": "Cerca indirizzi...",
    "admin.forward_conversion.confirm": "Convertire {email} in alias della casella {destination}? L’alias resterà collegato a questa casella se il suo indirizzo e-mail cambia.",
    "admin.forward_conversion.success": "Inoltro convertito in alias della casella",
    "admin.forward_conversion.failed": "Conversione non riuscita",
    "admin.forward_conversion.stale": "Questo inoltro non può più essere convertito. Ricarica la pagina del dominio.",
    "admin.forward_conversion.invalid": "address_id e mailbox_id devono essere interi positivi",
    "admin.forward_conversion.event": "Inoltro convertito in alias della casella",
} as const;
